var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderIconFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85709 12.506C6.37009 10.646 4.59609 8.6 3.62709 7.45C3.32709 7.094 3.22909 6.833 3.17009 6.374C2.96809 4.802 2.86709 4.016 3.32809 3.508C3.78909 3 4.60409 3 6.23409 3H17.7661C19.3961 3 20.2111 3 20.6721 3.507C21.1331 4.015 21.0321 4.801 20.8301 6.373C20.7701 6.832 20.6721 7.093 20.3731 7.449C19.4031 8.601 17.6261 10.651 15.1331 12.514C15.0178 12.6037 14.9225 12.7165 14.8533 12.8451C14.7841 12.9737 14.7425 13.1154 14.7311 13.261C14.4841 15.992 14.2561 17.488 14.1141 18.244C13.8851 19.466 12.1541 20.201 11.2261 20.856C10.6741 21.246 10.0041 20.782 9.93309 20.178C9.66756 17.8765 9.44286 15.5705 9.25909 13.261C9.24882 13.114 9.20771 12.9708 9.13845 12.8407C9.06919 12.7106 8.97333 12.5966 8.85709 12.506Z",
    stroke: "#363636",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderIconFilter);
export default __webpack_public_path__ + "static/media/header-icon-filter.64bbc7e9156f23d66cb0cc131e10c71d.svg";
export { ForwardRef as ReactComponent };